import { Component } from '@angular/core';
import { AuthService } from '@src/app/core/auth/auth.service';
import { APP_ROUTES } from '@src/app/core/constants/app-routes';
@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent {
      constructor(private authService: AuthService) { }
    
    public APP_ROUTES = APP_ROUTES;
    user: any = this.authService.getUserData();
}
